import axiosInstance from 'interceptor/axiosInstance';
import {
  FlatTransportationDetails,
  TransportationDetails,
} from 'models/Farmbox/transportation.model';
import { useState } from 'react';
import { generatePath } from 'react-router-dom';
import { ApiRoutes } from 'routes/routeConstants/apiRoutes';
import { deserialize, serialize } from 'serializr';
import {
  transformFlatToHierarchical,
  transformHierarchicalToFlatStructure,
} from 'shared/utils/convertFarmTransportationData';
import Notification from 'shared/components/Notification';
import { NotificationTypes } from 'enums/notificationTypes';
import { StageUpdatingMessage } from 'constants/constants';

const FarmTransportationService = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const [draftButtonLoading, setDraftButtonLoading] = useState<boolean>(false);
  const [transportationData, setTransportationData] =
    useState<TransportationDetails>();

  const { STAGE_2 } = StageUpdatingMessage;

  const fetchTransportationData = async (pathParams: {
    commodityId?: string;
  }) => {
    const { commodityId } = pathParams;

    try {
      setLoading(true);
      const url = generatePath(ApiRoutes.CREATE_COMMODITY_TRANSPORTATION, {
        commodityId,
      });
      const response = await axiosInstance.get(url);
      const transportationResponse = deserialize(
        FlatTransportationDetails,
        response.data
      );
      const hierarchicalData = transformFlatToHierarchical(
        transportationResponse
      );

      setTransportationData(hierarchicalData);
      return hierarchicalData;
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const updateTransportationData = async (
    commodityId?: string,
    transportation?: TransportationDetails
  ) => {
    try {
      setButtonLoading(true);
      const url = generatePath(ApiRoutes.CREATE_COMMODITY_TRANSPORTATION, {
        commodityId,
      });
      const flatData =
        transportation && transformHierarchicalToFlatStructure(transportation);

      const serializedData = serialize(FlatTransportationDetails, flatData);

      await axiosInstance.put(url, serializedData);
      Notification({
        message: STAGE_2,
        description: '',
        type: NotificationTypes.SUCCESS,
      });
      return true;
    } catch (error) {
      return false;
    } finally {
      setButtonLoading(false);
    }
  };

  const updateTransportationDataAsDraft = async (
    commodityId?: string,
    transportation?: TransportationDetails,
    params?: { saveDraft: boolean }
  ) => {
    try {
      setDraftButtonLoading(true);
      const url = generatePath(ApiRoutes.CREATE_COMMODITY_TRANSPORTATION, {
        commodityId,
      });
      const flatData =
        transportation && transformHierarchicalToFlatStructure(transportation);

      const serializedData = serialize(FlatTransportationDetails, flatData);

      await axiosInstance.put(url, serializedData, { params: { draft: params?.saveDraft } });
      Notification({
        message: STAGE_2,
        description: '',
        type: NotificationTypes.SUCCESS,
      });
      return true;
    } catch (error) {
      return false;
    } finally {
      setDraftButtonLoading(false);
    }
  };
  return {
    loading,
    transportationData,
    fetchTransportationData,
    updateTransportationData,
    buttonLoading,
    updateTransportationDataAsDraft,
    draftButtonLoading,
  };
};
export default FarmTransportationService;
